import React from "react";
import { Route, Switch } from "react-router-dom";

import Add from "./Add";
import Upload from "./Upload";
import UploadVarience from "./UploadVarience";
import List from "./List";
import Summary from "./Summary";

import StrRmUpload from "./str_rm/Upload";
import StrRmList from "./str_rm/List";
import StrRmSummary from "./str_rm/Summary";
import StrRmAdd from "./str_rm/Add";
import StrRmGrn from "./str_rm/Grn";
import StrRmEdit from "./str_rm/Edit";

import SiluetaSummary from "./silueta/Summary";

import PrymUpload from "./prym/Upload";
import PrymList from "./prym/List";
import PrymSummary from "./prym/Summary";
import PrymAdd from "./prym/Add";
import PrymGrn from "./prym/Grn";

import OtrUpload from "./otr/Upload";
import OtrList from "./otr/List";
import OtrSummary from "./otr/Summary";
import OtrAdd from "./otr/Add";
import OtrGrn from "./otr/Grn";

import TiepUpload from "./tiep/Upload";
import TiepList from "./tiep/List";
import TiepSummary from "./tiep/Summary";
import TiepAdd from "./tiep/Add/Add";
import TiepGrn from "./tiep/Grn";
import TiepAddViaJobTask from "./tiep/AddViaJob";
import TiepAsyCudaUpload from "./tiep/UploadAsyCuda";
import TiepAsycuda from "./tiep/Asycuda";
import TiepDocuments from "./tiep/Documents";
import TiepHistory from "./tiep/History";
import TiepReciptTransactions from "./tiep/Transactions";
import TiepRecieptImported from "./tiep/Add/ImportedRecipt";

import AquaUpload from "./aqua/Upload";
import AquaList from "./aqua/List";
import AquaSummary from "./aqua/Summary";
import AquaAdd from "./aqua/Add";
import AquaGrn from "./aqua/Grn";
import AquaEdit from "./aqua/Edit";
import AquaHistory from "./aqua/History";
import AquaDocuments from "./aqua/Documents";

import { Auth } from "_helpers";
import TiepTransactions from "./tiep/Transactions";

function StockReceipts({ match }) {
  const { path } = match;
  const loggedInCustomerCode = Auth.getProfile().comp_code;
  if (loggedInCustomerCode === "SILUETA") {
    return (
      <Switch>
        <Route exact path={path} component={List} />
        <Route path={`${path}/add`} component={Add} />
        <Route path={`${path}/upload`} component={Upload} />
        <Route path={`${path}/upload-variance`} component={UploadVarience} />
        <Route path={`${path}/:id/summary`} component={SiluetaSummary} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "PRYM") {
    return (
      <Switch>
        <Route exact path={path} component={PrymList} />
        <Route path={`${path}/add`} component={PrymAdd} />
        <Route path={`${path}/upload`} component={PrymUpload} />
        <Route path={`${path}/upload-variance`} component={UploadVarience} />
        <Route path={`${path}/:id/summary`} component={PrymSummary} />
        <Route path={`${path}/:id/grn`} component={PrymGrn} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "STR") {
    return (
      <Switch>
        <Route exact path={path} component={StrRmList} />
        <Route path={`${path}/add`} component={StrRmAdd} />
        <Route path={`${path}/upload`} component={StrRmUpload} />
        <Route path={`${path}/upload-variance`} component={UploadVarience} />
        <Route path={`${path}/:id/summary`} component={StrRmSummary} />
        <Route path={`${path}/:id/grn`} component={StrRmGrn} />
        <Route path={`${path}/:id/edit`} component={StrRmEdit} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "OTR") {
    return (
      <Switch>
        <Route exact path={path} component={OtrList} />
        <Route path={`${path}/add`} component={OtrAdd} />
        <Route path={`${path}/upload`} component={OtrUpload} />
        <Route path={`${path}/upload-variance`} component={UploadVarience} />
        <Route path={`${path}/:id/summary`} component={OtrSummary} />
        <Route path={`${path}/:id/grn`} component={OtrGrn} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "TIEP") {
    return (
      <Switch>
        <Route exact path={path} component={TiepList} />
        <Route path={`${path}/add`} component={TiepAdd} />
        <Route
          path={`${path}/add-via-job-task`}
          component={TiepAddViaJobTask}
        />
        <Route path={`${path}/upload`} component={TiepUpload} />
        <Route path={`${path}/:id/summary`} component={TiepSummary} />
        <Route path={`${path}/:id/grn`} component={TiepGrn} />
        <Route path={`${path}/:id/asycuda`} component={TiepAsycuda} />
        <Route path={`${path}/:id/history`} component={TiepHistory} />
        <Route path={`${path}/:id/documents`} component={TiepDocuments} />
        <Route
          path={`${path}/:id/transactions`}
          component={TiepReciptTransactions}
        />
        <Route path={`${path}/upload-asycuda`} component={TiepAsyCudaUpload} />
        <Route exact path={`${path}/add`} component={TiepAdd} />
        <Route path={`${path}/imported`} component={TiepRecieptImported} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "AQUA") {
    return (
      <Switch>
        <Route exact path={path} component={AquaList} />
        <Route path={`${path}/add`} component={AquaAdd} />
        <Route path={`${path}/upload`} component={AquaUpload} />
        <Route path={`${path}/:id/summary`} component={AquaSummary} />
        <Route path={`${path}/:id/grn`} component={AquaGrn} />
        <Route path={`${path}/:id/edit`} component={AquaEdit} />
        <Route path={`${path}/:id/history`} component={AquaHistory} />
        <Route path={`${path}/:id/documents`} component={AquaDocuments} />
      </Switch>
    );
  } else {
    return (
      <Switch>
        <Route exact path={path} component={List} />
        <Route path={`${path}/add`} component={Add} />
        <Route path={`${path}/upload`} component={Upload} />
        <Route path={`${path}/upload-variance`} component={UploadVarience} />
        <Route path={`${path}/:id/summary`} component={Summary} />
      </Switch>
    );
  }
}

export { StockReceipts };
